module.exports = __webpack_public_path__ + "img/img_size3_jf.474bc356.png";